import HomeIcon from './component'

export default HomeIcon